import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./What_Makes_Hindustan_Solar_Different.css";
import { WhatMakeDifferents } from "../../../utils/apis/aboutus/Aboutus.js";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const WhatMakesHindustanDifferent = () => {
  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);
  const [whatmakedifferent, setWhatMakeDifferent] = useState([]);

  const getWhatMakeDifferent = async () => {
    const res = await WhatMakeDifferents();
    if (res?.success) {
      setWhatMakeDifferent(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getWhatMakeDifferent();
  }, []);

  return (
    <section className="hindustan_section">
      <Container>
        <Row className="align-items-stretch justify-content-center hindustan_row">
          
          {/* Left Column: Image Card Frame */}
          <Col lg={5} md={5}  className="">
            <div className="hindustan_image_card">
              <img
                src="/assets/images/aboutus/ITSM.png"
                alt=" Technical Field Engineer"
                className="solar_man_img"
              />
              <div className="image_accent_badge">
                <span>100% Certified</span>
                <p>EPC Professionals</p>
              </div>
            </div>
          </Col>

          {/* Right Column: Premium Content Blocks */}
          <Col lg={7} md={7}>
            <div className="hindustan_content_card">
              <span className="section_subtitle">WHY CHOOSE US</span>
              <h2 className="hindustan_title">
                What Makes Deligencia Different?
              </h2>

              <div className="points_wrapper">
                {whatmakedifferent.map((item, index) => (
                  <div className="single_point_card" key={index}>
                    <div className="point_header">
                      <div className="point_counter">
                        {String(index + 1).padStart(2, '0')}
                      </div>
                      <h4 className="point_name">{item?.name}</h4>
                    </div>
                    <div className="point_body">
                      {htmlToReactParser.parse(item?.description)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default WhatMakesHindustanDifferent;